import React from 'react';

const COMPANY = [
  { label: 'Focus',    href: '#focus' },
  { label: 'Research', href: '#research' },
  { label: 'Work',     href: '#work' },
  { label: 'People',   href: '#people' },
];

const RESOURCES = [
  { label: 'Open source',   href: '#open-source' },
  { label: 'Writing',       href: '#writing' },
  { label: 'Resources page ↗', href: '/landing-zone' },
  { label: 'Contact',       href: '#contact' },
];

const REACH = [
  { label: 'jb@jishutech.io',   href: 'mailto:jb@jishutech.io' },
  { label: 'LinkedIn ↗',        href: 'https://www.linkedin.com/in/jbellish', external: true },
  { label: 'GitHub ↗',          href: 'https://github.com/jb-612', external: true },
  { label: 'WhatsApp ↗',        href: 'https://wa.me/16463356845?text=Hi%20Jonathan', external: true },
];

const CHANNELS = [
  { label: 'Discord ↗',  href: 'https://discord.gg/wbpDeubktu', external: true },
  { label: 'Telegram ↗', href: 'https://t.me/jishutech',        external: true },
];

export default function Footer() {
  return (
    <footer style={{ padding: '48px 32px 32px', background: 'var(--ink)', color: 'var(--paper)', position: 'relative', zIndex: 1 }}>
      <div className="container">
        <div className="mobile-collapse-5" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', gap: 32, alignItems: 'start', paddingBottom: 48, borderBottom: '1px solid rgba(244,236,224,0.12)' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontFamily: 'var(--font-display)', fontStyle: 'italic', fontSize: 28, letterSpacing: '-0.01em', color: 'var(--paper)' }}>
                Jishu<span style={{ color: 'var(--clay)' }}>·</span>tech
              </span>
            </div>
            <p style={{ marginTop: 16, fontSize: 14, color: 'rgba(244,236,224,0.6)', maxWidth: '36ch', lineHeight: 1.55 }}>
              A research foundation for applied AI in financial services. Operators, engineers, and domain experts.
            </p>
            <p style={{ marginTop: 12, fontSize: 12, color: 'rgba(244,236,224,0.4)', fontFamily: 'var(--font-mono)', letterSpacing: '0.04em' }}>
              +1 (929) 333 3540 · office
            </p>
          </div>
          <FooterCol title="Company"   items={COMPANY} />
          <FooterCol title="Resources" items={RESOURCES} />
          <FooterCol title="Reach"     items={REACH} />
          <FooterCol title="Channels"  items={CHANNELS} />
        </div>
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'rgba(244,236,224,0.5)', letterSpacing: '0.04em' }}>
            © 2012 JISHU TECHNOLOGIES · TEL AVIV · NEW YORK
          </div>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'rgba(244,236,224,0.5)', letterSpacing: '0.04em' }}>
            v0.1 · DRAFT FOR FOUNDER REVIEW
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(244,236,224,0.5)', marginBottom: 16 }}>
        {title}
      </div>
      <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {items.map((it) => (
          <li key={it.label}>
            <a
              href={it.href}
              {...(it.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              style={{
                color: 'var(--paper)',
                fontSize: 14,
                textDecoration: 'none',
                opacity: it.placeholder ? 0.5 : 0.85,
                fontStyle: it.placeholder ? 'italic' : 'normal',
              }}
              title={it.placeholder ? 'Placeholder — invite link pending' : undefined}
            >
              {it.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
